import React from 'react';

import Seo from '../ui/Seo';
import PageHero from '../sections/PageHero';
import TradeTicker from '../sections/TradeTicker';
import Pledge from '../sections/Pledge';
import StoryDeck from '../sections/StoryDeck';
import SectionHead from '../sections/SectionHead';
import Faqs from '../sections/Faqs';
import Cta from '../sections/Cta';

import BackupGenerators from "../media/images/power-systems/backup-generators.jpg";
import SolarPowerSystems from "../media/images/power-systems/solar-power-systems.jpg";
import BatteryStorageSystems from "../media/images/power-systems/battery-storage-systems.jpg";
import UpsSystems from "../media/images/power-systems/ups-systems.jpg";
import EnergyAudits from "../media/images/power-systems/energy-audits.jpg";
import PowerSystemUpgrades from "../media/images/power-systems/power-system-upgrades.jpg";

const content =
[
    {
        title: "Backup Generators",
        text: "Ensure your home or business remains powered during outages with our reliable backup generator solutions. We provide installation, maintenance, and repairs for generators of all sizes to keep your property running smoothly.",
        imgSrc: BackupGenerators,
        alt: "Backup Generators - Smart Electric Solutions",
        focus: "90%",
    },
    {
        title: "Solar Power Systems",
        text: "Reduce energy costs and embrace sustainable power with our solar panel installation services. Our expert team ensures seamless integration and long-lasting performance for residential and commercial properties.",
        imgSrc: SolarPowerSystems,
        alt: "Solar Power Systems - Renewable Energy Solutions",
        focus: "60%",
    },
    {
        title: "Battery Storage Systems",
        text: "Maximize your energy efficiency with advanced battery storage solutions. Store excess solar energy or ensure a reliable backup source with our cutting-edge systems tailored to your needs.",
        imgSrc: BatteryStorageSystems,
        alt: "Battery Storage Systems - Energy Efficiency",
        focus: "50%",
    },
    {
        title: "UPS Systems",
        text: "Protect your sensitive equipment from power interruptions with uninterruptible power supply (UPS) systems. Ideal for businesses and home offices, our UPS solutions ensure uninterrupted productivity and safety.",
        imgSrc: UpsSystems,
        alt: "UPS Systems - Power Protection",
        focus: "50%",
    },
    {
        title: "Energy Audits",
        text: "Identify energy inefficiencies and optimize your electrical system with our professional energy audit services. Our detailed reports help you save money and reduce your carbon footprint.",
        imgSrc: EnergyAudits,
        alt: "Energy Audits - Efficiency Optimization",
        focus: "50%",
    },
    {
        title: "Power System Upgrades",
        text: "Modernize your electrical infrastructure with our power system upgrade services. From panel upgrades to advanced electrical solutions, we enhance the reliability and efficiency of your property’s power systems.",
        imgSrc: PowerSystemUpgrades,
        alt: "Power System Upgrades - Modern Electrical Solutions",
        focus: "45%",
    }
];

export default function PowerSystems() {
    return (
        <>
            <Seo
                title="Power Systems"
                description="Backup generators, UPS systems, battery storage, solar power and power system upgrades engineered for South Florida buildings."
                keywords="backup generators, UPS systems, battery storage, solar power systems, power system upgrades, energy audits, South Florida"
                path="/power-systems"
                schema={{
                    '@type': 'WebPage',
                    name: 'Power Systems',
                    description: 'Backup generators, UPS systems, battery storage, solar power and power system upgrades engineered for South Florida buildings.',
                    url: 'https://smartelectric.solutions/power-systems'
                }}
            />

            <PageHero
                eyebrow="Systems"
                title="Power that stays on when the grid does not."
                lead="Standby generation, storage and solar, specified against your real load profile and commissioned properly rather than left for the next contractor to figure out."
                backdrop={content[0].imgSrc}
                focus={`${content[0].focus} center`}
                crumbs={[{ label: 'Systems' }, { label: 'Power Systems' }]}
            />

            <TradeTicker />

            <section className="section section--tight">
                <div className="shell">
                    <Pledge />
                </div>
            </section>

            <section className="section section--ruled">
                <div className="shell">
                    <SectionHead
                        eyebrow="What we build"
                        title="Generation, storage and distribution."
                        lead="Each system sized from measured consumption, installed to code, and documented for whoever maintains it next."
                    />
                </div>

                <div style={{ marginTop: 'clamp(2.5rem, 6vw, 4rem)' }}>
                    <StoryDeck items={content} />
                </div>
            </section>

            <Faqs />
            <Cta />
        </>
    );
}
